import React from 'react'
import './PWA.css'
import Header from '../Header/Header'
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash'
import PWAData from '../../Components/Admin/PWAData/PWAData'

export default function PWA() {
    return (
        <div className='containerGrid'>
            <Header />
            <section className='containerSection'>
                <HeaderDash />
                <div className='container'>
                    <PWAData />
                </div>
            </section>
        </div>
    )
}



